var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpCarrotBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 575 607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle_1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "288 98 5.7 523 570.3 523 288 98"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpCarrotBlackIcon);
export default __webpack_public_path__ + "static/media/UpCarrot_BlackIcon.18502fa35e7415a5c10a042a70cb86b4.svg";
export { ForwardRef as ReactComponent };